<div class="flex flex-col fill">
  <mic-header>
    <div class="flex flex-row fill justify-between">
      <div class="flex items-center header-left">
        <mic-sidebar-toggler
          [matTooltip]="translationService.translate('toggleSidebarText')"
          [matTooltipPosition]="'right'"
          [alwaysDisplay]="true"
          id="white-sidebar"
        >
        </mic-sidebar-toggler>
        @if (isChangePasswordPage) {
        <a>
          <mic-logo type="commercial" ariaLabel="Home - Bib Tread Next" link="/authlogin" width="227px" height="67px"></mic-logo>
        </a>
        } @else {
        <a>
          <mic-logo type="commercial" ariaLabel="Home - Bib Tread Next" link="/home/dashboard" width="227px" height="67px"></mic-logo>
        </a>
        }

        <span class="btn-version">BTN V4</span>
      </div>
      @if ((isTranslationsLoading$ | async) === false) {
      <div class="flex flex-row flex-none gap-8 items-center xs-justify-end">
        @if (reportUrl) {
        <a
          [matTooltip]="translationService.translate('opensBtnReportsText')"
          [matTooltipPosition]="'left'"
          [href]="reportUrl"
          target="_blank"
          rel="noopener noreferrer"
          id="btn-report-link"
          class="btn-report-link"
        >
          {{ translationService.translate('btnReportText') }}
        </a>
        } @if (zoneImageUrl$ | async; as zoneImageUrl) {
        <img [src]="zoneImageUrl" alt="Zone logo" id="zone-logo" style="height: 70px; width: 190px; border-radius: 4px" />
        }
        <!-- Notification Bell -->
        <app-notification-bell></app-notification-bell>
        <button
          [matMenuTriggerFor]="profileMenu"
          [matTooltip]="translationService.translate('goToProfileText')"
          mat-icon-button
          id="profile-menu"
          [matTooltipPosition]="'left'"
          style="background-color: white; font-weight: lighter; font-size: 1rem; width: 3rem; height: 3rem; color: black"
        >
          {{ profileName }}
        </button>
        <mat-menu #profileMenu="matMenu" class="custom-menu">
          <ng-container>
            <div mat-menu-item (click)="$event.stopPropagation()">
              <strong>{{ firstName }} {{ lastName }}</strong>
            </div>
          </ng-container>

          @if (isUserMgmtEnabled) {
          <button id="change-password-button" mat-menu-item (click)="navigateToChangePassword()">
            <mat-icon>lock_open</mat-icon>
            <span>{{ translationService.translate('changePasswordText') }}</span>
          </button>
          }
          <ng-container>
            <app-language-dropdown id="app-language-dropdown" (click)="$event.stopPropagation()"></app-language-dropdown>
          </ng-container>
          <ng-container>
            <app-logout></app-logout>
          </ng-container>
        </mat-menu>
      </div>
      }
    </div>
  </mic-header>

  <mic-sidebar-container leftToggler="main-sidebar-toggler">
    <mic-main-content main>
      <div class="flex flex-col fill justify-between" content>
        <div class="sidebar-container-content">
          <router-outlet></router-outlet>
        </div>
        <mic-footer>
          <div class="flex flex-row flex-1 items-center justify-between footer-content">
            <div class="footer-left">
              <a
                routerLink="/home/help/accessibility-statement"
                style="color: white; text-decoration: underline"
                id="accessibility-statement-footer-link"
              >
                {{ translationService.translate('accessibilityStatementText') }}
              </a>
            </div>
            <div class="flex flex-1 flex-col justify-center items-center footer-text">
              <div>
                BTN Support Email:
                <a href="mailto:btn.support@michelin.com" style="color: white" id="feedback-link">btn.support&#64;michelin.com</a>
              </div>
              <div>Copyright Michelin © {{ year }} Michelin North America, Inc. All Rights Reserved</div>
            </div>
            <div class="version xs-self-center">Version {{ version }}</div>
          </div>
        </mic-footer>
      </div>
    </mic-main-content>
  </mic-sidebar-container>
  <mic-alert-center></mic-alert-center>
</div>
